export const giftCardPrices = [1000, 3000, 5000, 10000, 15000];
